










































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TableComponent
  from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/table-goal-setting.component.vue';
import Wrapper from '@/modules/business-plan/common/business-plan-page-wrapper.component.vue';
import moment from 'moment';

import {AxiosError} from 'axios';
import {i18nMixin} from '@/modules/neodash/mixins';
import {Getter} from 'vuex-class';
import {notificationService} from '@/services';
import {Client} from '@/store/modules/authentication/interfaces';
import {AUTH_GET_CLIENT} from '@/store/modules/authentication/types';
import {BPA_ROUTES} from '@/modules/business-plan/router';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {salesTypes} from '../../../models/constants/salesTypes';

import { EconomicGroup, Families, Project,} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {ApprovalService} from '@/modules/business-plan/modules/services/approval.service';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import {EconomigGroupGoalDetail} from '@/modules/business-plan/modules/models/economigGroupGoalDetail';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {SalesChannel} from '@/modules/direct-sales/enums';
import {BpaSpreadsheetGoalsPerMonth} from '@/modules/business-plan/modules/services/bpa-spreadsheet-goal-per-month';
import data from '*.json';

interface InvalidFamilies {
  idFamily: number;
  nameFamily: string;
  goalValue: number;
  ttlGoalValuePerMonth: number;
}

@Component({
  name: 'ToyotaGoalSettingPage',
  components: {TableComponent, Wrapper}
})
export default class ToyotaGoalSettingPage extends Vue{
  public readonly translate = i18nMixin.methods.i18n;
  public BPA_ROUTES = BPA_ROUTES;

  public project: Project;
  public economicGroup: EconomicGroup = {} as EconomicGroup;
  public families: Families = [];
  public goalDetails: EconomigGroupGoalDetail[] = [];
  public invalidFamilies: InvalidFamilies[] = [];
  public originalGoalValues: TupleDictionary<[number], number> = new TupleDictionary<[number], number>();
  public componentKey: number = 1;
  public confirmNegotiate: boolean = false;

  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Prop({required: true})
  public idProject: number;

  @Prop({required: true})
  public idGroup: number;

  @Prop({required: true})
  public idLocale: number;

  @Watch('economicGroup.details', { immediate: true, deep: true })
  onPropertyChanged() {
    if(this.economicGroup.details) {
      this.economicGroup.details.map(detail => {
        if (detail.goalValue === this.originalGoalValues.get([detail.idFamily]))
          return;

        this.goalDetails.findOrFirst(x => x.idFamily == detail.idFamily).goalValue = detail.goalValue;
        this.goalDetails
            .findOrFirst(x => x.idFamily == detail.idFamily)
            .generateGoalPerMonthValues(this.familiesCalcGoal.findOrFirst(f => f.id === detail.idFamily), this.dictDistribution);

        this.originalGoalValues.set([detail.idFamily], detail.goalValue);
      });
    }
  }

  public created() {
    const {GetProject, GetGoalDefinitionData, ListFamilies} = ApprovalService;

    Promise.all([GetProject(this.idProject), GetGoalDefinitionData(this.idProject, this.idGroup, this.idLocale), ListFamilies(this.idProject)])
        .then(([project, goalDefinition, families]) => {
          this.project = project;
          this.families = families;
          this.economicGroup = goalDefinition;

          this.goalDetails = this.economicGroup.details
              .filter(detail => this.familiesCalcGoal.map(x => x.id).includes(detail.idFamily))
              .map(x => new EconomigGroupGoalDetail(x, this.familiesCalcGoal.findOrFirst(f => f.id === x.idFamily), this.dictDistribution));

          this.economicGroup.details
              .map(x => this.originalGoalValues.set([x.idFamily], x.goalValue));
        });
  }

  public downloadGoalsPerMonth() {
    const dataSource = Object.assign({}, this.economicGroup);
    dataSource.details = this.goalDetails;

    const spreadsheet = new BpaSpreadsheetGoalsPerMonth().mount([dataSource]);
    spreadsheet.name = `${spreadsheet.name}_${moment(new Date).year()}`;
    spreadsheet.create().saveAsExcel();
  }

  public toggleInvalidFamiliesModal() {
    this.invalidFamilies = [];
  }

  public getGoalDetail(idFamily: number) : EconomigGroupGoalDetail {
    return this.goalDetails.findOrFirst(x => x.idFamily === idFamily);
  }

  public getTtlGoalDetail(month: number | undefined = undefined) : number {
    return this.goalDetails
        .map(x => x.getTtlGoalPerMonthBy(undefined, month))
        .flat()
        .sum();
  }

  public isValidGoalPerMonth(idFamily: number) : boolean {
    return this.getGoalDetail(idFamily).getTtlGoalPerMonthBy() === this.economicGroup.details.findOrFirst(x => x.idFamily === idFamily).goalValue;
  }

  public get isNegotiateConcluded(): boolean {
    return this.economicGroup.details && this.economicGroup.details.some(x => x.isNegotiateConcluded)
  }

  public get titleGoalSetting(): string {
    const titles = ['Title', 'GoalSetting.Title']
        .map(x => this.translate(`BusinessPlan.${x}`))
        .join(' - ');

    return `${this.client.name} - ${titles}`;
  }

  public get hasThreats() : boolean {
    return this.invalidFamilies.length > 0;
  }

  public get tables(): GoalSettingColumns[] {
    if (!this.families.length || !this.economicGroup.details.length)
      return [];

    const { yearReference } = this.project;
    return [new GoalSettingColumns(yearReference, salesTypes.findOrFirst(x => x.value === SaleTypeEnum.DirectSales), this.client)];
  }

  public get dictDistribution() : TupleDictionary<[number, SalesChannel, number], number> {
    const dict = new TupleDictionary<[number, SalesChannel, number], number>();
    this.economicGroup.distributions
        .map(distribution => {dict.set([distribution.monthReference, distribution.saleChannel, distribution.idFamily], distribution.value)});

    return dict;
  }

  public get familiesCalcGoal(): Families {
    return this.families.filter(x => x.isCalcGoal);
  }

  public get months(): string[] {
    if (!this.economicGroup.distributions || !this.economicGroup.distributions.length)
      return [];

    return [...new Set<string>(Array.from(this.economicGroup.distributions.sortBy(x => x.monthReference), x => x.monthDescription))];
  }

  public validGoalSettings() {
    this.economicGroup.details = this.economicGroup.details
        .filter(detail => this.familiesCalcGoal.map(x => x.id).includes(detail.idFamily));

    this.economicGroup.details.forEach(detail => {
      detail.goalPerMonths = this.getGoalDetail(detail.idFamily).goalPerMonths;
      detail.goalPerMonths.map(x => { x.goalValue = !x.goalValue ? 0 : x.goalValue });

      if (!this.isValidGoalPerMonth(detail.idFamily))
        this.invalidFamilies.push({
          idFamily: detail.idFamily,
          nameFamily: this.families.findOrFirst(x => x.id == detail.idFamily).name,
          goalValue: detail.goalValue,
          ttlGoalValuePerMonth: this.getGoalDetail(detail.idFamily).getTtlGoalPerMonthBy()
        });
    });

    if (!this.invalidFamilies.length)
      this.saveGoalSettings();
  }

  public forceSaveGoalSettings() {
    this.economicGroup.details = this.economicGroup.details
        .filter(detail => this.familiesCalcGoal.map(x => x.id).includes(detail.idFamily));

    this.economicGroup.details.forEach(detail => {
      this.getGoalDetail(detail.idFamily).setGoalValue(this.getGoalDetail(detail.idFamily).getTtlGoalPerMonthBy());

      detail.goalPerMonths = this.getGoalDetail(detail.idFamily).goalPerMonths;
      detail.goalPerMonths.map(x => { x.goalValue = !x.goalValue ? 0 : x.goalValue });

      detail.goalTypeSelected = this.getGoalDetail(detail.idFamily).goalTypeSelected;
      detail.goalValue = this.getGoalDetail(detail.idFamily).goalValue;

      this.originalGoalValues.set([detail.idFamily], detail.goalValue);
    });

    this.saveGoalSettings();
    this.toggleInvalidFamiliesModal();

    this.componentKey += 1;
  }

  public saveGoalSettings() {
    if (this.isNegotiateConcluded)
      return false;

    this.economicGroup.details.forEach(x => x.isNegotiateConcluded = true);
    ApprovalService.SaveGoalSettingsPerMonth(this.idProject, this.economicGroup)
        .then(res => {
          notificationService.sendToast({
            status: 1,
            type: 'success',
            message: 'Metas salvas com sucesso!'
          });
        })
        .catch((err: AxiosError) => {
          notificationService.sendToast({
            status: 0,
            type: 'error',
            message: 'Ocorreu um erro por favor, tente novamente.'
          });
        });
  }

  public openConfirmNegotiateModal() {
    this.confirmNegotiate = true;
  }

  public back() {
    this.$router.push({name: this.BPA_ROUTES.HOME});
  }

  private toggleConfirmNegotiateModal() {
    this.confirmNegotiate = !this.confirmNegotiate;
  }
}
